import { useState } from "react";
import { Share2, Copy, Check, QrCode, X } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

/* Branded splink.pro short link + QR for any airport/airline/route page. */
export const ShareShortLink = ({ path, alias, label = "Share", className = "" }) => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [copied, setCopied] = useState(false);

  const mint = () => {
    if (data?.short_url) { setOpen(true); return; }
    setBusy(true);
    const url = `https://airlinesairports.com${path}`;
    api.post("/splink/share", { url, alias })
      .then((r) => {
        if (r.data.short_url) { setData(r.data); setOpen(true); }
        else toast.error("Short link service unavailable right now");
      })
      .catch((err) => toast.error(err.response?.data?.detail || "Could not create share link"))
      .finally(() => setBusy(false));
  };

  const copy = () => {
    navigator.clipboard.writeText(data.short_url).then(() => {
      setCopied(true); toast.success("Short link copied");
      setTimeout(() => setCopied(false), 1500);
    });
  };

  return (
    <>
      <button onClick={mint} disabled={busy} data-testid="share-short-link-btn"
        className={`inline-flex items-center gap-2 px-4 py-2.5 font-600 text-sm bg-white/15 text-white border border-white/40 hover:bg-white/25 transition-colors ${className}`}>
        <Share2 className="w-4 h-4" /> {busy ? "…" : label}
      </button>
      {open && data && (
        <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/50 p-4" onClick={() => setOpen(false)} data-testid="share-short-link-modal">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm text-zinc-900" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between">
              <div className="font-heading font-800 text-base flex items-center gap-2"><QrCode className="w-5 h-5 text-blue-700" /> Share this page</div>
              <button onClick={() => setOpen(false)} data-testid="share-modal-close" className="p-1 rounded hover:bg-zinc-100"><X className="w-4 h-4" /></button>
            </div>
            {data.qr_url && (
              <img src={data.qr_url} alt="QR code for short link" className="w-44 h-44 mx-auto my-4" data-testid="share-qr-img" />
            )}
            <div className="flex items-center gap-2 border border-zinc-300 rounded-lg px-3 py-2">
              <span className="flex-1 min-w-0 truncate text-sm font-700 text-blue-700 notranslate" data-testid="share-short-url">{data.short_url}</span>
              <button onClick={copy} data-testid="share-copy-btn" className="shrink-0 text-zinc-500 hover:text-blue-700">
                {copied ? <Check className="w-4 h-4 text-emerald-600" /> : <Copy className="w-4 h-4" />}
              </button>
            </div>
            <p className="text-[11px] text-zinc-400 mt-3">Branded short link with click analytics — perfect for print, TV and social.</p>
          </div>
        </div>
      )}
    </>
  );
};
